import { UserSelectDialog } from "components/UserSelectDialog";
import { useUpdateActivityAssignees } from "./index";
import { useCallback } from "react";

type AssignDialogProps = {
  activityIds: string[];
  onClose: () => void;
  open: boolean;
};

export function AssignDialog({
  activityIds,
  onClose,
  open,
}: AssignDialogProps) {
  const [updateActivityAssignees, { loading }] = useUpdateActivityAssignees();

  const handleAssign = useCallback(
    (assigneeId: string | null) => {
      updateActivityAssignees({
        variables: {
          assigneeId,
          ids: activityIds,
        },
        onCompleted: () => {
          onClose();
        },
      });
    },
    [activityIds, onClose, updateActivityAssignees]
  );

  return (
    <UserSelectDialog
      open={open}
      onSelect={handleAssign}
      onClose={onClose}
      title="Assign Activities"
    />
  );
}

export function useUnassignActivities() {
  const [updateActivityAssignees, { loading }] = useUpdateActivityAssignees();
  const unassign = useCallback(
    (activityIds: string[]) => {
      updateActivityAssignees({
        variables: {
          assigneeId: null,
          ids: activityIds,
        },
      });
    },
    [updateActivityAssignees]
  );

  return {
    unassign,
    loading,
  };
}
